import React from 'react';
import { Configuration } from '~/pages/Responsive/PaymentMethods/ConfigurationOffstorePay/components/Configuration';
import Header from '../../Header';
import * as S from './styles';

function ConfigurationOffstorePayConfig({ handleClickBackButton }) {
  return (
    <S.Container>
      <Header
        title="Offstore Pay - Ativar"
        handleClickBack={handleClickBackButton}
      />
      <S.Body>
        <Configuration />
      </S.Body>
    </S.Container>
  );
}

export default ConfigurationOffstorePayConfig;
